import BaseApi from "api/baseApi";
import { ROOM_HS_STAFF } from "../../apiConstant";

class HSRoom extends BaseApi {
  createRoom(body: { target_id: number }) {
    return this.post(ROOM_HS_STAFF, {
      ...body,
      target_type: "home_system_admin",
    });
  }

  getContactList(body: {
    per?: number;
    page?: number;
    unread?: boolean;
    search?: string;
  }) {
    return this.get(ROOM_HS_STAFF, body);
  }

  getContactDetail(body: { id: number; per: number; page: number }) {
    return this.get(
      `${ROOM_HS_STAFF}/${body.id}?per=${body.per}&page=${body.page}`
    );
  }

  createMessage(body: { id: number; content: string }) {
    return this.post(`${ROOM_HS_STAFF}/${body.id}/messages`, body);
  }

  readMessage(id: number) {
    return this.put(`${ROOM_HS_STAFF}/${id}`, {});
  }
}

export default HSRoom;
